const initState = {
    monitoreo_List: null,
    monitoreo_List_Error: null,   
    monitoreo_Success_Message: null, 
    monitoreo_Error_Message: null, 
    monitoreo_Data: null,
    monitoreo_Recolecciones_Data: null,
    monitoreo_Recolecciones_Totales: null,
    monitoreo_Recolecciones_Detalle: null,
    monitoreo_Reparto_Data:null,
    monitoreo_Guia_Data:null,
    loading: null
}

const monitoreoReducer = (state = initState, action) => {
    switch (action.type) {
        case "MONITOREO_LIST_SUCCESS":
            return {
                ...state,
                monitoreo_List: action.payload.data,
                monitoreo_Error_Message: null,
                monitoreo_Data: null,
                monitoreo_Recolecciones_Data: null,
                monitoreo_Recolecciones_Totales: null,
                monitoreo_Recolecciones_Detalle: null,
            }
        case "MONITOREO_LIST_ERROR":
            return {
                ...state,
                monitoreo_List: null,
                monitoreo_Error_Message: action.payload.error,
                monitoreo_Data: null,
                monitoreo_Recolecciones_Data: null,
                monitoreo_Recolecciones_Totales: null,
                monitoreo_Recolecciones_Detalle: null,
            }
        case "MONITOREO_OBTENER_REPARTOS":
            return {
                ...state,
                monitoreo_Data: action.payload.data,
                monitoreo_Error_Message: null,
            }
        case "MONITOREO_OBTENER_RECOLECCIONES":
            // No limpia monitoreo_Error_Message: es una carga secundaria en paralelo
            // y no debe tapar un error del fetch principal de repartos.
            return {
                ...state,
                monitoreo_Recolecciones_Data: action.payload.data,
            }
        case "MONITOREO_RECOLECCIONES_ERROR":
            // Falla de la carga secundaria: degrada en silencio (sin circulos),
            // sin tocar monitoreo_Data/monitoreo_List ni el mensaje de error.
            return {
                ...state,
                monitoreo_Recolecciones_Data: null,
            }
        case "MONITOREO_OBTENER_RECOLECCIONES_TOTALES":
            return {
                ...state,
                monitoreo_Recolecciones_Totales: action.payload.data,
            }
        case "MONITOREO_RECOLECCIONES_TOTALES_ERROR":
            return {
                ...state,
                monitoreo_Recolecciones_Totales: null,
            }
        case "MONITOREO_OBTENER_RECOLECCIONES_DETALLE":
            return {
                ...state,
                monitoreo_Recolecciones_Detalle: action.payload.data,
            }
        case "MONITOREO_RECOLECCIONES_DETALLE_ERROR":
            return {
                ...state,
                monitoreo_Recolecciones_Detalle: null,
            }
        case "MONITOREO_OBTENER_REPARTO":
            return {
                ...state,
                monitoreo_Reparto_Data: action.payload.data,
                monitoreo_Error_Message: null,
            }
        case "MONITOREO_OBTENER_GUIA":
            return {
                ...state,
                monitoreo_Guia_Data: action.payload.data,
                monitoreo_Error_Message: null,
            }
        case "MONITOREO_LIMPIAR_REPARTO":
            return {
                ...state,
                monitoreo_Reparto_Data: null,
            }
        default:
            return state;
    }
};


export default monitoreoReducer;